import React, { useEffect, useState } from "react";
import link from "../../assets/img/link.png";
import profile from "../../assets/img/profile.png";
import "./grievance.css";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  addCommentforGrievance,
  getGrievanceDetaildata,
  patchGrievanceRejacedApprovedata,
} from "../../redux/Action";
import moment from "moment";
import Selector from "../../components/common/selects/Selector";
import SpinnerLoader from "../../components/common/spinnerloader/SpinnerLoader";

const ViewGrievance = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [commentValue, setCommentValue] = useState();
  const [showError, setShowError] = useState(false);

  const pageLoading = useSelector((state) => state.main.loading);

  const { allGrievanceDetailList, allGrievanceRejApp, allgrievancelist } =
    useSelector((state) => state?.main);

  const pathname = location.pathname;

  const pathParts = pathname.split("/");

  const userId = pathParts[pathParts.length - 1];
  const Attendance = {
    records: [
      {
        status: "Store Manager",
        reason: allGrievanceDetailList?.data?.managerName,
      },
      {
        status: "Location",
        reason: allGrievanceDetailList?.data?.storeAddress,
      },
      {
        status: "Shift Time",
        reason: allGrievanceDetailList?.data?.shiftName,
      },
    ],
  };

  useEffect(() => {
    dispatch(getGrievanceDetaildata(userId));
    setShowError(false);
  }, [dispatch, userId, allGrievanceRejApp, allgrievancelist]);

  const handleChange = (status) => {
    const isCommentSectionEmpty =
      !allGrievanceDetailList?.data?.comments ||
      allGrievanceDetailList.data.comments.length === 0 ||
      allGrievanceDetailList.data.comments.every(
        (c) => !c.comment || c.comment.trim() === ""
      );

    if (status === "Rejected") {
      if (isCommentSectionEmpty) {
        setShowError(true);
      } else {
        dispatch(patchGrievanceRejacedApprovedata(status, userId));
      }
    } else {
      dispatch(patchGrievanceRejacedApprovedata(status, userId));
    }
  };

  const commentChangeHandler = (e) => {
    setCommentValue({ ...commentValue, [e.target.name]: e.target.value });
  };

  const submitCommentHandler = () => {
    const data = {
      comment: commentValue?.comment,
    };
    dispatch(addCommentforGrievance(data, userId, navigate, setCommentValue));
  };
  const liStyle = {
    color: "#2C357D",
  };
  const parastyle = {
    color: "#000",
  };
  return (
    <>
      {pageLoading ? (
        <SpinnerLoader />
      ) : (
        <div className="content-wrapper">
          <div className="wrap">
            <div className="container-fluid flex-grow-1 pt-4">
              <div className="logo_texts">
                <div className="logo_icons">
                  {allGrievanceDetailList?.data ? (
                    <img
                      src={allGrievanceDetailList.data.profileImage}
                      alt="Profile"
                      width={100}
                      height={100}
                      style={{ objectFit: "cover", borderRadius: "50px" }}
                    />
                  ) : (
                    <p>No image available</p>
                  )}{" "}
                </div>
                <div className="d-flex flex-column justify-content-start align-items-start  ">
                  <div className="des_texts d-flex  justify-content-start gap-3 pr-4">
                    <h5> {allGrievanceDetailList?.data?.employee_name}</h5>

                    <p style={liStyle}>
                      {allGrievanceDetailList?.data?.appliedDate
                        ? moment(
                            allGrievanceDetailList.data.appliedDate
                          ).format("DD MMMM YYYY : h:mm A")
                        : "No date available"}
                    </p>
                  </div>
                  <div className="d-flex justify-content-start gap-2">
                    <span
                      style={liStyle}
                      className="d-flex lign-item-start justify-content-start gap-2"
                    >
                      to:{" "}
                      <p style={parastyle}>
                        {allGrievanceDetailList?.data?.employee_email}
                      </p>{" "}
                    </span>

                    {allGrievanceDetailList?.data?.adminEmail && (
                      <span
                        style={liStyle}
                        className="d-flex lign-item-start justify-content-start gap-2"
                      >
                        cc:{" "}
                        <p style={parastyle}>
                          {allGrievanceDetailList?.data?.adminEmail}
                        </p>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex align-item-center justify-content-center gap-3 mobileSecView">
                {Attendance?.records?.map((record, index) => (
                  <div className="cardmornings">
                    <div className="right_reqs">
                      <h4>{record?.status}</h4>
                      <div className="min_flex_reqs">
                        <h1>{record?.reason}</h1>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="para_lorems">
                <div className="head_viewss">
                  <div className="application_pins">
                    <h6>Griveance</h6>
                    <img src={link} alt="" />
                  </div>
                </div>
                <div className="lorem_texts">
                  <p>{allGrievanceDetailList?.data?.description}</p>
                </div>
              </div>

              {/* <div className="btn_accept">
            <div className="accept_1">
              <button onClick={() => handleChange("Approved")}>Accept</button>
            </div>
            <div className="reject_1">
              <button onClick={() => handleChange("Rejected")}>Reject</button>
            </div>
          </div> */}
              {/* {allGrievanceDetailList?.data?.status !== "Approved" ? (
            <div className="btn_accept">
              <div className="accept_1">
                <button onClick={() => handleChange("Approved")}>Accept</button>
              </div>
              <div className="reject_1">
                <button onClick={() => handleChange("Rejected")}>Reject</button>
              </div>
            </div>
          ) : allGrievanceDetailList?.data?.status !== "Rejected" ? (
            <div className="btn_accept">
              <div className="accept_1">
                <button onClick={() => handleChange("Approved")}>Accept</button>
              </div>
              <div className="reject_1">
                <button onClick={() => handleChange("Rejected")}>Reject</button>
              </div>
            </div>
          ) : allGrievanceDetailList?.data?.status == "Pending" ? (
            <div className="btn_accept">
              <div className="accept_1">
                <button onClick={() => handleChange("Approved")}>Accept</button>
              </div>
              <div className="reject_1">
                <button onClick={() => handleChange("Rejected")}>Reject</button>
              </div>
            </div>
          ) : null} */}
              {allGrievanceDetailList?.data?.status !== "Approved" &&
                allGrievanceDetailList?.data?.status !== "Rejected" &&
                allGrievanceDetailList?.data?.status == "Pending" && (
                  <div className="btn_accept">
                    <div className="accept_1">
                      <button onClick={() => handleChange("Approved")}>
                        Approve
                      </button>
                    </div>
                    <div className="reject_1">
                      <button onClick={() => handleChange("Rejected")}>
                        Reject
                      </button>
                    </div>
                  </div>
                )}
              <div className="add_textarea">
                <div className="heading_add">
                  <h3>Add Comment</h3>
                </div>
                <textarea
                  placeholder="Describe yourself here..."
                  onChange={commentChangeHandler}
                  name="comment"
                ></textarea>
              </div>
              <p
                style={{ textAlign: "start", color: "red", marginTop: "-20px" }}
              >
                {showError && "Add a comment to reject a griveance ! "}
              </p>
              <div className="submit_buttons">
                <button onClick={() => submitCommentHandler()}>Submit</button>
              </div>
              <div className="para_loremss">
                <div className="head_views">
                  <div className="application_pins">
                    <h6>History of comments</h6>
                  </div>
                </div>
                <div className="lorem_textss2 border-bottom-0 pt-2 ">
                  {allGrievanceDetailList?.data?.comments?.map(
                    (data) =>
                      data?.comment && (
                        <div
                          key={data.id}
                          className="d-flex justify-content-between align-items-start"
                        >
                          <p>{data?.comment}</p>{" "}
                          <p className="d-flex flex-column justify-content-start latPara">
                            <span>Name : {data?.commentedBy?.name}</span>{" "}
                            {/* <span>
                              Designation: {data?.commentedBy?.designation}
                            </span> */}
                            <span className="helops">
                              Date & Time :{" "}
                              <span>
                                {moment(data?.createdAt).format("YYYY-MM-DD")}{" "}
                              </span>
                              <span className="ml-5">
                                {moment(data?.createdAt).format("hh:mm A")}
                              </span>
                            </span>
                          </p>
                        </div>
                      )
                  )}
                </div>
              </div>

              {/* <div className="canditate_selector">
        <Selector label="Blood Group" />
      </div> */}
              {/* <div className="submit_buttons">
          <button>Submit</button>
        </div> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewGrievance;
